export default {
  name: "WildcardPage",
  serverPrefetch() {
    const pageResponseCacheTtl = this.$config.pageResponseCacheTtl || "0";
    this.$ssrContext.res.setHeader(
      "cache-control",
      `public, max-age=${pageResponseCacheTtl}`
    );
  },
  asyncData({ app, store, error }) {
    // No match means 404 (the route does not exist anywhere and is caught here)
    const route = app.context.route.path;
    return store.dispatch("routes/lookupRoute", route).then((result) => {
      if (result === undefined) {
        error({ statusCode: 404, message: "Page Not Found" });
      } else {
        return result;
      }
    });
  },
  computed: {
    getGlobalToasts() {
      const globalToasts = this.$store.getters["storyblok/globalToasts"];
      if (globalToasts.data.length) {
        return globalToasts.data.filter((it) => !this.$cookies.get(it._uid));
      }
      return [];
    },
    toasts() {
      if (this.component === "storyblok") {
        const page = this.$store.getters["storyblok/getStoryById"](this.id);
        if (page && page?.content?.toasts) {
          return page?.content?.toasts.filter(
            (it) => !this.$cookies.get(it._uid)
          );
        }
      }
      return [];
    },
    classes() {
      if (this.component === "storyblok") {
        const page = this.$store.getters["storyblok/getStoryById"](this.id);
        const classes = [
          `block-spacing mbs--${page?.content?.blockSpacingMobile}`,
          `block-spacing dbs--${page?.content?.blockSpacingDesktop}`,
          `bg-color--${page?.content?.backgroundColor}`,
          `header-bgcolor--${page?.content?.headerBackgroundColor}`,
          `header-color--${page?.content?.headerColor}`,
        ];
        if (page?.content?.hideFooter === "1") {
          classes.push("hide-footer");
        }
        if (page?.content?.hideStory === "1") {
          classes.push("hide-story");
        }
        if (page?.content?.hideUsp === "1") {
          classes.push("hide-usp");
        }
        if (page?.content?.hideFooterMenu === "1") {
          classes.push("hide-footer-menu");
        }
        return classes;
      }
      return [];
    },
  },
  mounted() {
    this.$sysend.on("checkoutSuccess", () => {
      window.location.reload(true); // forced reload
    });
    this.$sysend.on("cartupdate", (msg) => {
      console.groupCollapsed("sysend recieved");
      console.log(msg);
      console.trace();
      console.groupEnd();
      // msg.forceReload is only in checkout
      this.$store.dispatch("centra-cart/checkoutUpdate");
    });
  },
  beforeDestroy() {
    this.$sysend.off("checkoutSuccess");
    this.$sysend.off("cartupdate");
  },
};
